// extracted by mini-css-extract-plugin
export default {"section":"PyTz06R5","counters":"v_uWLhWl","treeDiv":"fTtYviCU","heading":"W4Znqyyu","subheading":"sGBT0Olv","counterSubtext":"j3FSE84K","countersContainer":"K56AggIL"};